"use client";
import { LanguageSwitcher as SharedLanguageSwitcher, type LanguageSwitcherProps as SharedProps } from "@dj/site-navigation/language-switcher";
import { Link } from "@/i18n/navigation";
export type LanguageSwitcherProps = Omit<SharedProps, "LinkComponent">;
export function LanguageSwitcher(props: LanguageSwitcherProps) { return <SharedLanguageSwitcher {...props} LinkComponent={Link} />; }
